var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBellV2Read({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9409 20.4965L18.828 18.3497V11.3388C18.828 7.03727 14.5956 4 10.0003 4C5.40509 4 1.17271 7.03571 1.17271 11.3372V18.3482L0.0598095 20.495C0.0091356 20.6133 -0.00977067 20.7415 0.00474577 20.8683C0.0192622 20.9951 0.0667588 21.1166 0.143078 21.2222C0.219396 21.3278 0.32221 21.4143 0.442519 21.4741C0.562828 21.5339 0.696963 21.5652 0.833183 21.5653H6.66682C6.66682 23.294 8.15357 24 10.0003 24C11.8471 24 13.3338 23.294 13.3338 21.5653H19.1675C19.3035 21.5651 19.4374 21.5338 19.5575 21.4741C19.6776 21.4144 19.7803 21.3281 19.8566 21.2227C19.9329 21.1172 19.9804 20.996 19.9951 20.8694C20.0098 20.7428 19.9912 20.6148 19.9409 20.4965ZM10.0003 22.8943C9.07362 22.8943 8.08358 22.4327 8.08358 21.5653H11.9171C11.9171 22.4327 10.927 22.8943 10.0003 22.8943ZM2.06325 20.0051L2.77946 18.7881C2.81903 18.6959 2.8394 18.5974 2.83946 18.4979V11.3357C2.83946 7.89383 6.32347 5.55709 10.0003 5.55709C13.6772 5.55709 17.1612 7.89383 17.1612 11.3357V18.4979C17.1612 18.5988 17.1812 18.6956 17.2212 18.7881L17.9374 20.0051H2.06325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBellV2Read);
export default __webpack_public_path__ + "static/media/notification-bell-v2-read.d2dd05dae6311f385af3c9deba4db65f.svg";
export { ForwardRef as ReactComponent };